<template>
  <div class="vacancy__container">
    <vtitle />

    <div class="settings-vacancy row-block">
      <div class="settings-vacancy__upload">
        <vcv-settings-tabs :tabs="tabs" :active-tab="activeTab" @change="activeTab = $event" />

        <div class="settings-vacancy__item-content is-hide" :class="{ 'is-show': activeTab === 'picture' }">
          <div v-if="errorsAtLogo.show || is_logo_delete || !vacancy_image" :class="['settings-vacancy__dragDrop']">
            <input
              id="file"
              type="file"
              name="file"
              accept="image/*"
              class="settings-vacancy__dragDrop-input"
              @change="filesChange($event.target.files)"
            />

            <label v-if="errorsAtLogo.show" class="helper">
              {{ errorsAtLogo.message }}
            </label>

            <div class="upload__description">
              <icon-upload class="settings-company__dragDrop-image" fill="#00d26e" />

              <div class="settings-company__dragDrop-subtitle">
                <span>{{ $tr('vacancy.preferences.settings.uploadLogo') }}</span>
              </div>
            </div>
          </div>

          <div v-if="!errorsAtLogo.show && vacancy_image && !is_logo_delete" class="upload-image">
            <div class="upload-image__content" @mouseover="hover_image = true" @mouseleave="hover_image = false">
              <img ref="vLogo" :src="vacancy_image" />

              <div v-if="hover_image || show_confirm" class="upload-image__header" @mouseover="hover_image = true">
                <div class="upload-image__btn-group">
                  <div
                    :class="['upload-image__btn upload-image__btn_new', { hovering: hover_new }]"
                    @mouseover="hover_new = true"
                    @mouseout="hover_new = false"
                  >
                    <icon-upload :fill="fill_new" />

                    <span>{{ $tr('vacancy.preferences.settings.uploadNewLogo') }}</span>

                    <input
                      id="file"
                      type="file"
                      name="file"
                      accept="image/*"
                      :class="['input', { 'disable-change': show_confirm }]"
                      @change="filesChange($event.target.files)"
                    />
                  </div>

                  <div
                    :class="['upload-image__btn', { hovering: hover_remove }]"
                    @mouseover="hover_remove = true"
                    @mouseout="hover_remove = false"
                    @click="show_confirm = true"
                  >
                    <icon-remove :fill="fill_remove" />
                    <span>{{ $tr('vacancy.preferences.settings.removeLogo') }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="show_confirm" class="upload-image__confirm">
              <div class="upload-image__confirm-quest">
                {{ $tr('vacancy.preferences.settings.questRemove') }}
              </div>

              <div>
                <vbutton
                  class="upload-image__confirm-btn"
                  label="common.yes"
                  color="grey"
                  text_color="red"
                  @click="remove_img"
                />

                <vbutton
                  class="upload-image__confirm-btn"
                  label="common.no"
                  color="grey"
                  @click="show_confirm = false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row-block is-hide" :class="{ 'is-show': activeTab === 'video' }">
      <settings-video-container
        :vacancy="vacancy"
        :remove-video-link="removeVideoLink"
        :display-video="activeTab === 'video'"
        @setVideoLink="SET_VIDEO_LINK"
        @setChange="setChange"
        @errSave="errSave"
      />
    </div>

    <div class="row-block">
      <div>
        <div class="vacancy-editor-label">
          {{ $tr('vacancy.preferences.settings.description') }}
        </div>

        <vcv-editor
          id="veditor-vacancy"
          ref="landingEditor"
          v-model="description"
          :placeholder="$tr('vacancy.preferences.settings.descriptionHelper')"
          resizable
          :toolbar-buttons="{
            font: true,
            size: true,
            bold: true,
            italic: true,
            underline: true,
            align: true,
            color: true,
            background: true,
            header: true,
            image: true,
            list: true,
            link: true,
            clean: true
          }"
          name="description"
          @input="update_description"
          @text-change="isTextChanged = true"
          @selection-change="is_selection_change_invoked = true"
        />
      </div>
    </div>

    <div class="row-block">
      <!-- Catch event, save to the local var -->
      <settings-sharing
        :local-link="localLink"
        :token="vacancy.token"
        :landing_url_path="local_landing_url_path"
        :preview_url="preview_url"
        :subdomain="subdomain"
        @saveLocalLink="localLink = $event"
        @set_preview_url="preview_url = $event"
        @err_save="errSave"
      />
    </div>

    <div class="button-wrapper">
      <vbutton
        class="vacancy-button"
        label="common.save"
        color="white"
        :loading="isLoading"
        :disabled="blockedSaveVacancy || isLoading"
        @click="save(false)"
      />

      <vbutton
        class="vacancy-button"
        label="vacancy.saveAndContinue"
        :loading="isLoading"
        :disabled="blockedSaveVacancy || isLoading"
        @click="save(true)"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import SettingsVideoContainer from '@/routes_new/inner/vacancy/components/SettingsVideoContainer';
import SettingsSharing from '@/routes_new/inner/vacancy/components/SettingsSharing';
import vtitle from '@/routes_new/inner/vacancy/components/vtitle';
import VcvSettingsTabs from '@/components/VcvSettingsTabs';

const IMAGE_MAX_SIZE_BYTES = 15 * 1024 * 1024;

export default {
  name: 'Index',

  components: {
    SettingsVideoContainer,
    SettingsSharing,
    vtitle,
    VcvSettingsTabs
  },

  data() {
    return {
      tabs: [
        {
          id: 'picture',
          title: this.$tr('vacancy.preferences.settings.imgHome'),
          tooltip: this.$tr('vacancy.preferences.settings.helperImage')
        },
        {
          id: 'video',
          title: this.$tr('vacancy.preferences.settings.videoHome'),
          tooltip: this.$tr('vacancy.preferences.settings.videoLinkHelper')
        }
      ],

      activeTab: 'picture', // picture or video tab
      localLink: '',
      removeVideoLink: false,
      noSave: false,
      errorsAtLogo: {
        show: false,
        message: ''
      },

      fileList: null,
      preview_img: null,
      isLoading: false,
      blockedSaveVacancy: false,
      is_logo_delete: false,
      imgSrc: '',
      show_confirm: false,
      hover_image: false,
      hover_new: false,
      hover_remove: false,
      isTextChanged: false,
      preview_url: false,
      descriptionTemp: '',
      is_selection_change_invoked: false
    };
  },

  computed: {
    ...mapState('vacancy_new', { vacancy: 'item' }),

    ...mapGetters('vacancy_new', { modules: 'modules/list' }),

    ...mapState('vacancy', ['local_landing_url_path']),

    enabledModules() {
      return this.modules.filter(item => item.is_enabled);
    },

    active_application() {
      return this.enabledModules.find(item => item.id === 'survey' && item.is_active);
    },

    active_test() {
      return this.modules.find(item => item.id === 'test' && item.is_active);
    },

    description: {
      get() {
        return this.vacancy ? this.vacancy.description : null;
      },

      set(val) {
        if (val !== this.description && this.isTextChanged) {
          this.$store.commit('vacancy/update', {
            model: this.vacancy,
            data: {
              description: val
            }
          });
        }
      }
    },

    vacancyLogo() {
      return this.vacancy ? this.vacancy.logo_url : null;
    },

    videoLink() {
      return this.vacancy.video_link;
    },

    isDefaultFile() {
      if (this.vacancyLogo && !this.fileList) {
        return true;
      }

      return false;
    },

    subdomain() {
      if (!window.location || !window.location.host) {
        return '';
      }

      if (window.location.hostname.indexOf('release-ai.vcv') !== -1) {
        return 'ai';
      } else if (window.location.hostname.indexOf('release-ru.vcv') !== -1) {
        return 'ru';
      }

      return window.location.hostname ? window.location.hostname.split('.').pop() : '';
    },

    hasFiles() {
      return this.fileList || this.isDefaultFile;
    },

    vacancy_image() {
      if (this.preview_img) {
        return this.preview_img;
      }

      return this.vacancyLogo;
    },

    fill_new() {
      return this.hover_new ? '#F4F5F7' : '#9FAAB6';
    },

    fill_remove() {
      return this.hover_remove ? '#F4F5F7' : '#9FAAB6';
    }
  },

  watch: {
    descriptionTemp(val, oldVal) {
      if (!oldVal && this.is_selection_change_invoked) {
        this.description = val;
      }
    }
  },

  async created() {
    await this.getUrlHistory();
  },

  mounted() {
    this.$nextTick().then(() => {
      this.setChange(false);
      // console.log(this.vacancy);
      if (this.vacancy && this.vacancy.is_video_landing) {
        this.activeTab = 'video';
        // this.$store.commit('vacancy/set_video_landing', true);
      }
    });

    this.$parent.$on('saveOnParent', () => {
      this.$emit('saveOnParent');
    });
  },

  destroyed() {
    this.$parent.$off('saveOnParent');
  },

  methods: {
    ...mapMutations('vacancy_new', ['SET_VIDEO_LINK', 'SET_VIDEO_LANDING']),

    ...mapMutations('vacancy', ['setChange']),

    ...mapActions('vacancy_new', { fetchVacancy: 'load' }),

    getYoutubeEmbedLink(url) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);

      if (match && match[2].length == 11) {
        return `https://www.youtube.com/embed/${match[2]}`;
      } else {
        return 'error';
      }
    },

    update_description(val) {
      this.description = val;
      this.descriptionTemp = val;
      // this.setChange(true);
    },

    successMessage() {
      this.$noty.success(this.$tr('vacancy.preferences.modals.saveSuccess.text'));
    },

    failureMessage() {
      this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text'));
    },

    errSave(val) {
      if (!val) {
        this.blockedSaveVacancy = true;
      } else {
        this.blockedSaveVacancy = false;
      }
    },

    addMedia(val) {
      if (val) {
        this.activeTab = 'video';
      } else {
        this.activeTab = 'picture';
      }

      this.SET_VIDEO_LANDING(val);
    },

    goToNextSection() {
      let next_section;

      if (this.enabledModules && this.enabledModules.length) {
        if (this.active_application) {
          next_section = 'application';
        } else if (this.active_test) {
          next_section = 'tests';
        } else {
          next_section = 'video';
        }
      }

      this.$router.push({ path: `/vacancies/${this.vacancy.id}/${next_section}` });
    },

    remove_img() {
      this.is_logo_delete = true;
      this.show_confirm = false;
      this.save(false);
    },

    filesChange(fileList) {
      if (!fileList.length) {
        return false;
      }

      this.setChange(true);

      if (!fileList[0].type.includes('image/')) {
        this.errorsAtLogo.message = this.$tr('profile.profileForm.photoSelector.format');
        this.errorsAtLogo.show = true;
        return false;
      }

      this.fileList = fileList;
      const file = fileList[0];

      if (file.size / IMAGE_MAX_SIZE_BYTES >= 15) {
        this.errorsAtLogo.message = this.$tr('profile.profileForm.photoSelector.tooLarge');
        this.errorsAtLogo.show = true;
        return false;
      }

      this.errorsAtLogo.show = false;

      if (typeof FileReader === 'function') {
        const reader = new FileReader();

        reader.onload = event => {
          this.imgSrc = event.target.result;
          this.preview_img = event.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.errorsAtLogo.message = this.$tr('profile.profileForm.photoSelector.dontSupport');
        this.errorsAtLogo.show = true;
      }
      this.is_logo_delete = false;
    },

    saveImage(isSave, isContinue) {
      if (isSave) {
        this.isLoading = true;

        this.$store
          .dispatch('vacancy/save', this.vacancy)
          .then(() =>
            this.$store.dispatch('vacancy/saveVacancyLogoRequest', {
              vacancyId: this.vacancy.id,
              logo: this.fileList[0]
            })
          )
          .then(() => {
            this.isLoading = false;
            this.successMessage();
            this.setChange(false);

            if (isContinue) {
              this.goToNextSection();
            }
          })
          .catch(() => {
            this.isLoading = false;
            this.failureMessage();
            this.setChange(false);
          });
      }
    },

    vacancy_save(isContinue) {
      this.$store
        .dispatch('vacancy/save', this.vacancy)
        .then(() => {
          return this.getUrlHistory();
        })
        .then(() => {
          this.isLoading = false;
          this.preview_url = false;
          this.setChange(false);
          this.successMessage();

          if (isContinue) {
            this.goToNextSection();
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.setChange(false);
          this.failureMessage();
        });
    },

    async save(isContinue = 'false') {
      this.isLoading = true;
      this.setChange(true);

      if (this.activeTab === 'video') {
        await this.vacancy_save(isContinue);
        this.is_logo_delete = true;
        this.vacancy.logo_url = null;
        this.vacancy.is_video_landing = true;
        await this.$store
          .dispatch('vacancy/removeVacancyLogoRequest', {
            vacancyId: this.vacancy.id
          })
          .then(async () => {
            await this.vacancy_save(isContinue);
          });
      } else {
        this.SET_VIDEO_LANDING(false);
        this.removeVideoLink = true;
        this.SET_VIDEO_LINK(null);
        this.vacancy.is_video_landing = false;

        if (this.fileList && this.fileList.length > 0) {
          await this.saveImage(true, isContinue);
          // await this.fetchVacancy(Number(this.$route.params.id));
          // this.setChange(true);
        } else if (this.is_logo_delete) {
          await this.$store
            .dispatch('vacancy/removeVacancyLogoRequest', {
              vacancyId: this.vacancy.id
            })
            .then(async () => {
              await this.vacancy_save(isContinue);
            });
        } else {
          await this.vacancy_save(isContinue);
        }
      }
    },

    async getUrlHistory() {
      await this.$store.dispatch('vacancy/url/getHistory', { vacancyId: this.vacancy.id });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vacancy__container {
  margin-bottom: 30px;
  max-width: 620px;
  min-height: calc(100vh - 64px);
}

h1,
p {
  margin: 0;
}

h1 {
  margin: 0 0 12px;
  font-size: 22px;
  font-weight: normal;
  color: #333333;
}

.row-block {
  display: flex;
  margin: 0 0 40px 0;
  align-items: flex-start;
  justify-content: space-between;

  &__label {
    display: flex;
    justify-content: space-between;
    & > div {
      width: 200px;
    }
  }

  div.help {
    padding-top: 38px;
    width: 100%;
    font-size: 15px;
    line-height: 22px;

    &.help__sharing {
      padding-top: 28px;
    }

    span {
      display: block;
      padding: 10px 15px;
      border-radius: 5px;
      background-color: $line-statuses-status-settings-bg;
    }
  }

  div.help__top {
    padding-top: 62px;
  }

  label {
    font-size: 15px;
    display: block;
    margin-bottom: 10px;
  }

  input[name='name'] {
    padding: 8px 5px;
  }

  input,
  textarea {
    width: 100%;
    font-size: 16px;

    &.registrationLink,
    &.videoLink {
      cursor: text;
      font-size: 16px;
    }
  }

  p {
    margin-left: 23px;
    width: 33.3333%;
  }
}
.settings-vacancy {
  margin-top: 13px;
  margin-bottom: 43px;

  &__upload {
    width: 100%;
    position: relative;
    margin-right: 0;
  }

  &__btn {
    display: flex;
    border-radius: 4px;
  }

  &__media {
    width: 50%;
    font-size: 15px;
    padding: 10px 0;
    text-align: center;
    cursor: pointer;
    border-top: 1px solid #d2d6e0;
    border-bottom: 1px solid #d2d6e0;
    border-left: 1px solid #d2d6e0;
    border-right: 1px solid #d2d6e0;
    transition: all linear 0.4s;

    &_img {
      border-radius: 2px 0 0 2px;
      margin-right: -1px;
    }

    &_video {
      border-left: 1px solid transparent;
      border-radius: 0 2px 2px 0;
    }

    &:hover {
      border: 1px solid #b3b7bd;
      background: #f4f5f7;
    }

    &.active {
      border: 1px solid #b3b7bd;
      background: #f4f5f7;
    }
  }

  &__item-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    position: relative;
  }

  &__img-name {
    margin: 25px 0 10px;
    font-size: 16px;
    display: block;
  }

  &__dragDrop {
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    font-size: 14px;
    color: #afafaf;
    cursor: pointer;
    background: $white;
    transition: background-color 0.7s;
    border: 1px dashed $green;
    border-radius: 5px;
    color: $green;
    box-sizing: border-box;
    height: 220px;
    width: 100%;
    margin-top: 20px;

    &.has-files {
      max-height: 220px;
      height: auto;
    }

    &:hover {
      border-style: solid;
    }

    & input.settings-vacancy__dragDrop-input {
      opacity: 0;
      top: 0;
      left: 0;
      width: 100%;
      position: absolute;
      z-index: 10;
      cursor: pointer;

      &#file {
        height: 100%;
      }
    }

    label.helper {
      display: block;
      color: $red-color;
      margin-bottom: 20px;
      font-weight: normal;
      padding-top: 5px;
    }

    img {
      max-height: 220px;
      height: auto;
      max-width: 360px;
      width: auto;
    }
  }
}

.vacancy__container ::v-deep {
  .ql-editor.ql-blank:before {
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    color: #9faab6;
  }

  .ql-editor {
    background: #fff;
  }
}

.settings-company__image {
  max-width: 300px;
  margin-right: 25px;
}

.settings-company__dragDrop-image {
  font-size: 14px;
  margin-right: 10px;
}

.settings-company__upload-input {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: -1;
}

.upload__description {
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-image {
  width: 100%;
  height: 100%;
  margin-top: 25px;

  &__content {
    position: relative;
  }

  &__header {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 70px;
    z-index: 9;
  }

  &__btn-group {
    display: flex;
    cursor: pointer;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &__btn {
    height: 100%;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9faab6;
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;

    &.hovering {
      color: #f4f5f7;
    }

    &_new {
      position: relative;
    }

    .input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 70px !important;
      cursor: pointer;
      opacity: 0;

      &.disable-change {
        pointer-events: none;
      }
    }

    span {
      display: inline-block;
      margin-left: 10px;
    }
  }

  &__confirm {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 0 5px;

    &-quest {
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: #233346;
    }

    &-btn {
      margin: 0 5px 0 2px;
    }
  }

  &__dragDrop-input {
    opacity: 0;
    top: 0;
    left: 0;
    width: 100%;
    position: absolute;
    z-index: 10;
    cursor: pointer;

    &#file {
      height: 100%;
    }
  }

  img {
    max-width: 100%;
    width: 100%;
    display: block;
  }
}

.column-checkbox {
  display: flex;
  font-size: 13px;
  line-height: 15px;
  + .column-checkbox {
    margin-top: 22px;
  }
}

.standart-navigation {
  margin: 25px 0;
  justify-content: flex-start;
}

.link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding-top: 5px;

  label {
    margin-bottom: 12px;
  }

  .registrationLink {
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.005em;
    color: $green;
  }

  .right-button {
    margin-left: 0;
    border: 1px solid #d2d6e0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
}

.date__row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 12px;
}

.date-block {
  margin-top: 50px;

  &:not(:last-child) {
    margin-right: 90px;
  }
}

label.date-title {
  font-weight: 300;
  line-height: 18px;
  font-size: 12px;
  letter-spacing: 0.005em;
  color: #233346;
}

.date-desc {
  margin-top: 13px;
  margin-bottom: 10px;
  font-weight: normal;
  line-height: 18px;
  font-size: 12px;
  letter-spacing: 0.005em;
  color: #233346;
}

.vacancy-photo {
  width: 100%;
  height: 100%;
  margin-top: 30px;
  z-index: 12;

  &__header {
    display: flex;
    margin-top: 10px;
  }

  &__btn-group {
    display: flex;
  }

  &__btn {
    margin-right: 10px;
  }

  &__footer {
    color: #f65046;
    margin-top: 10px;
  }
}

.border-button {
  position: relative;
  padding-right: 1px;

  &:before {
    content: '';
    position: absolute;
    width: 1px;
    height: 30px;
    top: 5px;
    bottom: 5px;
    left: -1px;
    background: #d3d6da;
  }

  &:hover:not(.disabled) {
    &:before {
      display: none;
    }

    & + .border-button:before {
      display: none;
    }
  }

  &:first-child {
    &:before {
      display: none;
    }
  }
}

.buttons-group {
  .vbutton {
    margin: 0;
  }
}

.button-wrapper {
  display: flex;
  margin-top: 50px;
  margin-bottom: 70px;

  .vacancy-button:not(:last-child) {
    margin-right: 10px;
  }
}

.sharing-list {
  display: flex;
  align-items: center;
}

::v-deep.sharing-item {
  margin-right: 10px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 2px;
  position: relative;
  overflow: hidden;

  &__vk {
    background: #4a76a8;
  }

  &__fb {
    background: #4267b2;
  }

  img {
    height: 41px;
    width: auto;
    position: absolute;
    left: 0;
    top: 0;
  }
}

.link-button-wrapper {
  min-width: 145px;
  display: flex;
  justify-content: flex-end;
}

.button-wrapper {
  .vacancy-button:not(:last-child) {
    margin-right: 10px;
  }
}
.link-button-wrapper {
  min-width: 145px;
  display: flex;
  justify-content: flex-end;
}

input,
textarea {
  width: 100%;
  font-size: 16px;

  &.registrationLink,
  &.videoLink {
    cursor: text;
    font-size: 16px;
  }
}

.vacancy-editor-label {
  @include mixin-text-header;
  display: block;
  margin-bottom: 12px;
}

.is-hide {
  opacity: 0;
  visibility: hidden;
  transition: opacity linear 0.4s;

  &:not(.is-show) {
    position: absolute;
    width: 0;
    height: 0;
  }

  &.is-show {
    opacity: 1;
    visibility: visible;
    transition: opacity linear 0.4s;
  }
}

.media-info-text {
  @include mixin-text-main;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    margin-left: 4px;
  }
}
</style>
